module.exports = __webpack_public_path__ + "img/ru_Beta Digitis - Gif.750400d1.gif";